import React, { useEffect } from "react"
import Loading from "components/Loading"
import { FullScreenOverlay } from "components/StyledComponents"
import api from "api"

export default function BillingPortal({ location }) {
  useEffect(() => {
    const getUrl = async () => {
      const response = await api.post(`user/stripe-portal`, undefined, {
        return_url: location
      })
      if (response.url) {
        window.location = response.url
      } else {
        window.location = location
      }
    }
    getUrl()
  }, [location])
  return (
    <FullScreenOverlay>
      <Loading />
    </FullScreenOverlay>
  )
}
